import React from 'react';
import { Link } from 'react-router-dom';
import { useScreen } from '@hooks/useScreen';
import darkLogo from '@assets/logo/ginastee-studio-dark.svg';
import lightLogo from '@assets/logo/ginastee-studio-light.svg';
import './styles.scss';

export default function StudioBrand({ onClick }) {
  const { resolvedAppearance } = useScreen();
  return <Link to="/studio" onClick={onClick} className="studio-brand" aria-label="Ginastee Studio"><img src={resolvedAppearance === 'dark' ? darkLogo : lightLogo} alt="Ginastee" /></Link>;
}
